import { IApplicationState } from '../types/redux';

export function getCategory(state: IApplicationState) {
  return state.filters.category;
}
